import React from 'react';

const SectionSummary = ({ takeaway, hmrcRef, actionText, actionLink }) => {
  return (
    <div className="my-8 bg-slate-900 border-l-4 border-l-indigo-500 border border-slate-700/50 rounded-r-xl p-6 shadow-md">
      <h5 className="text-xs font-bold uppercase tracking-widest text-indigo-400 mb-2">TL;DR Summary</h5>
      <p className="text-white font-medium text-lg mb-3">
        <strong>{takeaway}</strong>
      </p>
      
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mt-4 pt-4 border-t border-white/5">
        <span className="text-xs font-mono text-slate-400 bg-black/40 px-3 py-1.5 rounded-md border border-white/5">
          HMRC Reference: <span className="text-emerald-400 font-bold">{hmrcRef}</span>
        </span>
        
        {actionText && (
          <a 
            href={actionLink} 
            className="text-sm font-bold text-indigo-400 hover:text-indigo-300 transition-colors inline-flex items-center gap-1 group"
          >
            {actionText}
            <span className="group-hover:translate-x-1 transition-transform">→</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default SectionSummary;
